import React, { useEffect, useContext, useState } from 'react';
import { HttpMethods, FetchContext, ApiRoutes, ToastContext } from '../../../contexts';
import CircularProgress from '@material-ui/core/CircularProgress';
import { DateTime } from '../../../common';
import CheckIcon from '@material-ui/icons/Check';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import {
  Paper,
  Avatar,
  TableContainer,
  Table,
  TableHead,
  TableBody,  
  TableRow,
  TableCell,      
  Typography,
  Hidden,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  InputLabel,
  Grid,
  LinearProgress
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MyProjectsContext } from '../MyProjectsContext';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    overflowX: "initial"
  },
  viewName: {
    display: 'flex',
    alignItems: 'center',
    wordBreak: 'break-word'
  },
  header: {
    fontSize: '1rem'
  }
}));

export default function ViewsDialog(props){
  const classes = useStyles();

  const {
    saveUserSettingsAsync
  } = useContext(MyProjectsContext);

  const [isDialog, setIsDialog] = useState(false);
  const [isForm, setIsForm] = useState(false);
  const [newViewName, setNewViewName] = useState("");
  const [activatingView, setActivatingView] = useState(null);
  const [deletingView, setDeletingView] = useState(null);
  const [isAddingView, setIsAddingView] = useState(false);
  const [userViews, setUserViews] = useState(null); //null is the initial value. Only its change makes useEffect to trigger

  useEffect(() => {
    if (props.initialUserViews !== null){
      const allViews = [];

      if (props.initialUserViews.length > 0){
        props.initialUserViews.map(view => {
          const viewSettings = {
            id: view.userSettingsId,
            name: view.name,
            isUsed: view.isUsed,
            columns: JSON.parse(view.gridSettings)
          };

          allViews.push(viewSettings);
        });
      }

      setUserViews(allViews);
    }
  }, [props.initialUserViews])

  useEffect(() => {
    if (props.updatedView !== null){
      //removing deleted view from views array
      if (props.updatedView.isDeleted){
        const existingViews = userViews.filter(view => view.id !== deletingView);
        setUserViews(existingViews);
      }
      
      else {
        const allViews = userViews;
        const isNewView = !allViews.some(view => view.id === props.updatedView.userSettingsId);
        
        if (isNewView){
          allViews.map(view => view.isUsed = false);
  
          const newView = {
            id: props.updatedView.userSettingsId,
            name: props.updatedView.name,
            isUsed: true,
            columns: JSON.parse(props.updatedView.gridSettings)
          };
  
          allViews.push(newView);
        }
  
        else {
          allViews.map(view => {
            if (view.id === props.updatedView.userSettingsId)
              view.isUsed = props.updatedView.isUsed; //it should always be true
            else
              view.isUsed = false;
          });
        }
  
        setUserViews(allViews);
        setActivatingView(null);
      }
    }
  }, [props.updatedView])

  const createView = async () => {
    setIsAddingView(true);
    await props.addNewView(newViewName);
    setIsAddingView(false);
    setIsForm(false);
    setNewViewName("");
  }

  const activateView = async view => {
    setActivatingView(view.id);

    const wantedView = {
      userSettingsId: view.id,
      userKey: props.userInfo.externalKey,
      name: view.name,
      isUsed: true,
      toDelete: false,
      gridSettings: "",
      budgetYearId: props.layoutBudget.budgetYearId
    };
    
    await saveUserSettingsAsync(wantedView);
  }

  const deleteView = async view => {
    setDeletingView(view.id);

    const unwantedView = {
      userSettingsId: view.id,
      userKey: props.userInfo.externalKey,
      name: view.name,
      isUsed: true,
      toDelete: true,
      gridSettings: "",
      budgetYearId: props.layoutBudget.budgetYearId
    };
    
    await saveUserSettingsAsync(unwantedView);
    setDeletingView(null);
  }

  const closeDialog = () => {
    setIsDialog(false);
    setIsForm(false);
    setNewViewName("");
  }

  return (
    <span>
      <Button 
        color="primary"
        size="small"
        variant="contained"
        style={{marginRight: '15px', fontSize: '11px'}}
        onClick={() => setIsDialog(true)}
      >Views</Button>
      <Dialog
        open={isDialog}
        onClose={() => closeDialog()}
        aria-labelledby="form-dialog-title"
      >
        {!props.initialUserViews ?
        <LinearProgress color="primary" style={{margin: '15px 20px'}} /> :
        <>
          <DialogTitle id="form-dialog-title" style={{fontSize: '22px', height: '15%', display: 'flex', justifyContent: 'center'}}>
            {
              isForm ?
              "Add new view with current grid settings" :
              `Saved views (${props.layoutBudget && props.layoutBudget.observedYear})`
            }
          </DialogTitle>
          <DialogContent style={{margin: '0px 30px', height: '85%'}}>
            <div style={{height: '100%'}}>
              <div style={{height: '85%', overflowY: 'auto'}}>
                <TableContainer className={classes.container}>
                  <Table arial-label="role table" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.header} align="left" width="60%">
                          Name
                        </TableCell>
                        <TableCell className={classes.header} align="center" width="10%">
                          {isForm ? "" : "In use"}
                        </TableCell>
                        <TableCell className={classes.header} align="center" width="30%">
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        isForm ?
                        <TableRow hover>
                          <TableCell component="th" scope="row">
                            <div className={classes.viewName}>
                              <div style={{width: "100%"}}>
                                <TextField
                                  style={{display: "flex"}}
                                  value={newViewName ? newViewName : ""}
                                  onChange={event => {
                                    event.persist();
                                    setNewViewName(event.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </TableCell>
                          <TableCell align="center">
                            <Typography></Typography>
                          </TableCell>
                          <TableCell align="center">
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                              {
                                isAddingView ?
                                <CircularProgress /> :
                                <Button 
                                  color="primary"
                                  size="small"
                                  variant="contained"
                                  onClick={() => createView()}
                                  disabled={!newViewName}
                                >Save</Button>
                              }
                              {
                                !isAddingView &&
                                <Button
                                  size="small"
                                  variant="contained"
                                  style={{marginLeft: '20px'}}
                                  onClick={() => {
                                    setIsForm(false);
                                    setNewViewName("");
                                  }}
                                >Cancel</Button>
                              }
                            </div>
                          </TableCell>
                        </TableRow> :
                        props &&
                        props.userInfo &&
                        props.layoutBudget &&
                        userViews &&
                        userViews.length > 0 &&
                        userViews.map((view, index) =>
                          <TableRow hover key={index}>
                            <TableCell component="th" scope="row">
                              <div className={classes.viewName}>
                                <Typography>
                                  {view.name}
                                </Typography>
                              </div>
                            </TableCell>
                            <TableCell align="center">
                              <Typography>
                                {
                                  view.isUsed ?
                                  <CheckIcon /> :
                                  <HighlightOffIcon />
                                }
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <div style={{display: 'flex', justifyContent: 'center'}}>
                                {
                                  deletingView !== view.id && (
                                    activatingView === view.id ?
                                    <CircularProgress /> :
                                    !view.isUsed &&
                                    <Button 
                                      color="primary"
                                      size="small"
                                      variant="contained"
                                      onClick={() => activateView(view)}
                                    >Use</Button>
                                  )
                                }
                                {
                                  userViews &&
                                  userViews.length > 1 &&
                                  activatingView !== view.id &&
                                  (
                                    deletingView === view.id ?
                                    <CircularProgress color="secondary" /> :
                                    <Button 
                                      color="secondary"
                                      size="small"
                                      variant="contained"
                                      style={{marginLeft: '20px'}}
                                      onClick={() => {
                                        if (window.confirm("Are you sure you want to delete this view?"))
                                          deleteView(view);
                                      }}
                                    >
                                      Delete
                                    </Button>
                                  )
                                }
                              </div>
                            </TableCell>
                          </TableRow>
                        )
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div style={{height: '15%', display: 'flex', justifyContent: 'center'}}>
                {
                  !isForm &&
                  <div style={{alignSelf: 'center', marginRight: '5%'}}>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{fontSize: '12px'}}
                      onClick={() => setIsForm(true)}
                    >Add new view</Button>
                  </div>
                }
                <div style={{alignSelf: 'center'}}>
                  <Button
                    variant="contained"
                    style={{fontSize: '12px'}}
                    onClick={() => closeDialog()}
                  >Close</Button>
                </div>
              </div>
            </div>
          </DialogContent>
        </>
        }
      </Dialog>
    </span>
  );
}